import { capitalize } from '../../utils/utils';
import * as Style from '../Sidebar/style';

function FilterModeSelector({ filterMode, setFilterMode }) {
  return (
    <Style.Fieldset>
      <legend>Filter by</legend>
      {['index', 'date'].map(name => (
        <Style.RadioField key={name}>
          <input
            id={name}
            type="radio"
            value={name}
            checked={filterMode === name}
            onChange={e => setFilterMode(e.target.value)}
          />
          <Style.Label htmlFor={name}>{capitalize(name)}</Style.Label>
        </Style.RadioField>
      ))}
    </Style.Fieldset>
  );
}

export default FilterModeSelector;
